export default {
    AsterCampaign: {
        getdata: []
    }
};